import * as aesjs from "aes-js";
// AES-CBC key and IV are server-side secrets and must never be embedded in
// the client bundle.  This module intentionally does NOT read them from
// process.env — doing so would create the risk of them being baked into the
// webpack bundle if they were ever accidentally added to CLIENT_ENV_WHITELIST.
//
// Server-side callers that legitimately need AES-CBC must supply key and IV
// explicitly through the `config` parameter.  Browser callers omit `config`;
// the functions then behave as a pass-through (AES_CBC_ENABLED=false) or
// return `undefined` (AES_CBC_ENABLED=true without a valid config), which
// matches the pre-existing behaviour when the env vars were absent.
const enabled = process.env.AES_CBC_ENABLED === "true";
const padUint8ArrayToMultipleOf16 = (arr) => {
    const currentLength = arr.length;
    const remainder = currentLength % 16;
    if (remainder === 0) {
        return arr; // Already a multiple of 16
    }
    const paddingLength = 16 - remainder;
    const newArray = new Uint8Array(currentLength + paddingLength);
    // Copy original array into the new array
    newArray.set(arr);
    // The remaining elements are already zero by default, but if you want to be explicit:
    // newArray.fill(0, currentLength);
    return newArray;
};
export const avalancheDecrypt = (cypherText, config) => {
    if (enabled) {
        //console.log("avalanche encryption enabled");
        if (config === undefined) {
            //console.log("Decrypting", cypherText, "N/A");
            return undefined;
        }
        else {
            //console.log(cypherText);
            const encryptedBytes = aesjs.utils.hex.toBytes(cypherText);
            const aesCbc = new aesjs.ModeOfOperation.cbc(config.key, config.iv);
            const decryptedBytes = aesCbc.decrypt(encryptedBytes);
            const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
            //console.log("Decrypting", cypherText, decryptedText);
            return decryptedText;
        }
    }
    else {
        //console.log("avalanche encryption disabled");
        return cypherText;
    }
};
export const avalancheEncrypt = (plainText, config) => {
    if (enabled) {
        //console.log("avalanche encryption enabled");
        if (config === undefined) {
            //console.log("Encrypting", plainText, "N/A");
            return undefined;
        }
        else {
            const plainTextBytes = padUint8ArrayToMultipleOf16(aesjs.utils.utf8.toBytes(plainText));
            const aesCbc = new aesjs.ModeOfOperation.cbc(config.key, config.iv);
            const encryptedBytes = aesCbc.encrypt(plainTextBytes);
            const encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
            //console.log("Encrypting", plainText, encryptedHex);
            return encryptedHex;
        }
    }
    else {
        //console.log("avalanche encryption disabled");
        return plainText;
    }
};
